import { ImageFormatKey } from '@/resources/image-format';

export class ShapeBaseAttribute {
  // 数据源
  sourceEnabled = false;
  source?: string;
  valueStart: number | string = 0;
  valueEnd: number | string = 0;
  angleStart = 0;
  angleEnd = 360;

  recolorEnable = true;

  x = 0;
  y = 0;
  w = 100;
  h = 100;
  rotation = 0;

  /**
   * 图层名称
   *
   * @type {string}
   * @memberof ShapeBaseAttribute
   */
  name = '图层';

  /**
   * 是否展示图片格式下拉菜单
   *
   * @memberof ShapeBaseAttribute
   */
  showImgFormat = false;

  format?: ImageFormatKey;

  _visibility = true;
  _isLocked = false;

  _cloneFromId?: string;

  // resources: {
  //   [name: string]: LayerResourceItem;
  // } = {};

  /**
   * 温度单位类型，celsius=摄氏度 fahrenheit=华氏度 system=跟随系统
   * 用于进度条和数字填充的图组
   */
  temperatureUnitType: 'system' | 'celsius' | 'fahrenheit' = 'celsius';
}
